import { useEffect, useState, useMemo, useCallback } from 'react';

import Pagination from '../services/Pagination';

type Range = {
  start: number;
  end: number;
};

function getRange(itemsByPage: number, page: number): Range {
  const start = itemsByPage * (page - 1);
  const end = start + itemsByPage - 1;

  return { start, end };
}

type UsePaginationParams = {
  callback?: (start: number, end: number) => void;
  itemsByPage: number;
  defaultPage?: number;
};

type UsePaginationReturn = [Pagination, Range, (total?: number) => number];

export default function usePagination({
  callback,
  itemsByPage,
  defaultPage = 1,
}: UsePaginationParams): UsePaginationReturn {
  const [currentPage, setPage] = useState(defaultPage);
  const range = useMemo(() => getRange(itemsByPage, currentPage), [itemsByPage, currentPage]);

  const pagination = useMemo(() => new Pagination(setPage, defaultPage), [setPage, defaultPage]);
  const getTotalPages = useCallback((total = 0) => Math.ceil(total / itemsByPage), [itemsByPage]);

  useEffect(() => {
    if (!callback) {
      return;
    }

    const { start, end } = range;
    callback(start, end);
  }, [callback, range]);

  return [pagination, range, getTotalPages];
}
